import { render, staticRenderFns } from "./root-messages.vue?vue&type=template&id=0fa88605"
import script from "./root-messages.vue?vue&type=script&lang=js"
export * from "./root-messages.vue?vue&type=script&lang=js"
import style0 from "./root-messages.vue?vue&type=style&index=0&id=0fa88605&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports